// extracted by mini-css-extract-plugin
export default {"checkboxRoot":"multi-select_checkboxRoot__wA9jm","menuItemRoot":"multi-select_menuItemRoot__BsraY"};